import { IFlowItem } from "Flow/types/flow.types";

export const isItemError = (flowItem: IFlowItem) => (
    !!(flowItem?.isErrorOn && flowItem.error && flowItem.error !== 'none')
)